import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-banner-home-selection',
  templateUrl: './banner-home-selection.component.html',
  styleUrls: ['./banner-home-selection.component.scss']
})
export class BannerHomeSelectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
